<template>
    <div>
        <div class="mx-auto w-1/2 text-center">
            <h1 class="first-letter:uppercase text-heading-1 font-semibold mr-auto mb-16">{{ $t('import.step_2.title') }}</h1>
            <p class="text-primary-80 mb-48">{{ $t('import.step_2.description') }}</p>
        </div>


        <div class="grid grid-cols-1 gap-32 sm:grid-cols-2 mx-auto w-4/5 sm:w-3/5">
            <div :class="activeItem === 'type1' ? 'pointer-events-none border-secondary' : 'hover:border-primary-20 hover:bg-primary-5 bg-white border-primary-5'"
                 class="relative flex items-center justify-center rounded-6 border px-32 py-48 shadow"
            >
                <button class="cursor-pointer focus:outline-none"
                        role="button"
                        @click="changeActiveType('type1')"
                >
                    <span aria-hidden="true" class="absolute inset-0"></span>

                    <svg-icon
                        class="inline"
                        size="120"
                        type="import-candidates"
                    />

                    <span class="block max-w-prose25 mt-42">
                        {{ $t('import.step_2.choice1') }}
                    </span>
                </button>
            </div>

            <div :class="activeItem === 'type2' ? 'pointer-events-none border-secondary' : 'hover:border-primary-20 hover:bg-primary-5 bg-white border-primary-5'"
                 class="relative flex items-center justify-center rounded-6 border px-32 py-48 shadow"
            >
                <button class="cursor-pointer focus:outline-none"
                        role="button"
                        @click="changeActiveType('type2')"
                >
                    <span aria-hidden="true" class="absolute inset-0"></span>

                    <svg-icon
                        class="inline"
                        size="120"
                        type="add-new-job"
                    />

                    <span class="block max-w-prose25 mt-42">
                        {{ $t('import.step_2.choice2') }}
                    </span>
                </button>
            </div>
        </div>


        <p class="text-primary-80 my-32 text-center">
            <span v-if="activeItem === 'type1'">{{ $t('import.step_2.choice1_title') }}</span>
            <span v-if="activeItem === 'type2'">{{ $t('import.step_2.choice2_title') }}</span>
        </p>

        <div class="mx-auto w-2/5 text-center mt-32">
            <select-dropdown
                v-if="activeItem === 'type1'"
                :auto-translate="false"
                :options="jobOptions"
                :show-check-icon="true"
                :value="job_id"
                :placeholder="$t('import.general.choose_job')"
                searchable
                @change="setJob(null, $event)"
            />

            <select-dropdown
                v-if="activeItem === 'type2'"
                :auto-translate="false"
                :options="fieldOptions"
                :show-check-icon="true"
                :value="job_column"
                :placeholder="$t('import.general.choose_field')"
                searchable
                @change="setJob($event, null)"
            />

            <p v-if="jobsFound !== null" class="text-primary-80 my-32">{{ $t('import.step_2.choice2_title', {amount: jobsFound}) }}</p>
        </div>


        <div class="mt-48 flex justify-center space-x-20">
            <simple-button class="uppercase w-200"
                           look="secondary"
                           @click="$emit('previous')">
                {{ $t('general.back') }}
            </simple-button>

            <simple-button v-if="jobsFound || job_id"
                           class="uppercase w-200"
                           display="secondary"
                           look="primary"
                           @click="$emit('next')">
                {{ $t('jobs.next_step') }}
            </simple-button>
        </div>
    </div>
</template>

<script>
import SelectDropdown from '../../forms/SelectDropdown';
import uniq from 'lodash/uniq';
import SimpleButton from '../SimpleButton';
import Job from '../../../models/Job';
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../../state/store';
import {useJobsStore} from '../../../state/modules/jobs';
import SvgIcon from '../SvgIcon';

export default {
    components: {SvgIcon, SimpleButton, SelectDropdown},
    props: {
        file: File,
        data: Array,
        fields: Array,
        job_id: [Number, String],
        job_column: String,
        fieldOptions: Array,
    },
    data: function () {
        return {
            activeItem: '',
        };
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        jobsFound() {
            if (!this.job_column) {
                return null;
            }

            return uniq(this.data.map(app => app[this.job_column])).length;
        },
        jobOptions() {
            return useRepo(Job).all().map(job => ({
                value: job.id,
                label: job.title[this.locale],
            }));
        },
    },
    methods: {
        ...mapActions(useJobsStore, ['clear', 'fetch']),
        setJob(job_column, job_id) {
            this.$emit('setJob', {job_column: job_column, job_id: job_id});
        },
        changeActiveType(type) {
            this.setJob(null, null);

            this.activeItem = type;
        },
    },
    mounted() {
        if (this.job_id) {
            this.activeItem = 'type1';
        }
        if (this.job_column) {
            this.activeItem = 'type2';
        }

        this.fetch({
            filters: {},
            all: 1,
        });
    },
};
</script>
